export default __webpack_public_path__ + "static/char-v-49-cbe58faa28fccd4bc7663c82af48e1a6.png";